// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Instructions {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 2vh;
  font-family: 'Courier New', Courier;
  font-size: 16px;
  color: rgb(138, 122, 89);
  margin-left: 2lvw;
}

[data-theme='dark'] .Instructions {
  color: rgb(45, 184, 154);
}

.tennis-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 2vh;
}

.big-box {
  width: 15vw;
  height: 65vh;
  margin-left: 4vw;
  margin-right: 4vw;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.big-box img {
  width: 100%;
  height: 100%;
  object-fit: scale-down;
  /* object-fit: cover; */
}

.calendario-wrapper {
  position: absolute;
  top: 0;
  left: 33%;
  align-self: center;
  z-index: 2;
  top: 30%;
}

.torneo {
  align-self: center;
  position: absolute;
  width: 90%;
  z-index: 1;
  top: 40%;
}

.loading-container {
  top: 70%;
  z-index: 1;
}

.resultado-prediccion {
  position: absolute;
  top: 75%;
  z-index: 1;
}


.button {
  position: absolute;
  left: 50%;
  top: 85%;
  transform: translate(-50%, -50%);
  background-color: rgb(39, 117, 100);
  color: white;
  padding: 10px 32px;
  cursor: pointer;
  border-radius: 4px;
  z-index: 2;
}

[data-theme='light'] .button {
  background-color: rgb(204, 197, 176);
  color: rgb(82, 68, 49);
}

.button:hover {
  background-color: rgb(102, 86, 64);
}

.buscador-left,
.buscador-right {
  width: calc(45vh + 30px);
  height: calc(65vh + 30px);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 3vh;
}

.ganador {
  border: 10px solid rgb(39, 117, 100);
  border-radius: 3%;
}


[data-theme='light'] .ganador {
  border: 10px solid rgb(155, 135, 93);
}

.componentes-abajo {
  display: relative;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 2vh;
  width: 15vw;
  height: auto;
  max-height: 70vh;
  margin: 4vw;
}

@media screen and (max-width: 1000px) {

  .componentes-abajo {
    display: flex;
    flex-direction: row;
  }

  .buscador-left,
  .buscador-right {
    width: calc(40vw + 3vw);
    height: calc(35vh + 3vw);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 2vh;
  }

  [data-theme='light'] .ganador {
    border: 3px solid rgb(155, 135, 93);
  }

  .ganador {
    border: 3px solid rgb(155, 135, 93);
    border-radius: 3%;
  }

  .big-box {
    width: 10vw;
    height: 35vh;
    margin: 1vw;
  }

  .big-box img {
    width: 50%;
    object-fit: scale-down;
  }

  .buscador-container {
    width: 40vw;
    height: 35vh;
  }

  .buscador-jugadores {
    height: 4vh;
  }

  .ul-jugadores {
    max-height: 30vh;
  }

  .ul-buscador {
    max-height: 20vh;
  }

  .imagen {
    height: 30.5vh;
  }

  .calendario {
    width: 20vw;
    height: 3vh;
    align-self: start;
    margin-left: 10vw;
  }

  .calendario-wrapper {
    position: relative;
    align-self: start;
    top: 0vh;
  }

  .calendario,
  .input-jugadores {
    font-size: x-small;
    padding: 0px;
  }

  .buscador-torneo {
    height: 3vh;
    width: 65vw;
    font-size: x-small;
    margin-left: 10vw;
  }

  .contenedor-rondas-buttons {
    width: 75vw;
    display: flex;
    justify-content: space-between;
  }

  .ronda-seleccionada {
    border: 0.3vh solid rgba(177, 147, 50, 0.7);
  }

  .contenedor-rondas-buttons button {
    font-size: x-small;
    justify-content: start;
    flex-grow: 1;
    background-color: rgba(179, 179, 179, 0.7);
    height: 4vh;
    margin: 0 1vw;
    border-radius: 15%;
  }


  .calendario-opt {
    font-size: x-small;
  }

  .torneo {
    position: relative;
  }

  .button {
    position: absolute;
    left: 50%;
    top: 25vh;
    transform: translate(-50%, -50%);
    background-color: rgb(39, 117, 100);
    color: white;
    padding: 3px 6px;
    cursor: pointer;
    border-radius: 10px;
    z-index: 2;
    font-size: x-small;
  }

  .resultado-prediccion {
    top: 25vh;
  }

  .loading-container {
    top: 25vh;
    position: absolute;
    display: flex;
    overflow: hidden;
    font-size: x-small;
  }

  .tennis-ball {
    width: 15px;
    height: 15px;
    position: relative;
    animation: moveTennisBall 2s linear infinite;
  }

  .loading-text {
    font-size: 8px;
    color: #7c7979;
    margin-left: 0%;
  }

  @keyframes moveTennisBall {

    0%,
    100% {
      left: 0;
      transform: translateY(0);
    }

    25%,
    75% {
      left: calc(50% - 15px);
      transform: translateY(20px);
    }

    50% {
      left: calc(100% - 15px);
      transform: translateY(0);
    }
  }

}
`, "",{"version":3,"sources":["webpack://./src/Pages/Projects/Tennis/Tennis.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,mCAAmC;EACnC,eAAe;EACf,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;AACZ;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,iBAAiB;AACnB;;;AAGA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,WAAW;AACb;;AAEA;;EAEE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;;IAEE,uBAAuB;IACvB,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,mCAAmC;EACrC;;EAEA;IACE,mCAAmC;IACnC,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,UAAU;IACV,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,iBAAiB;IACjB,QAAQ;EACV;;EAEA;;IAEE,kBAAkB;IAClB,YAAY;EACd;;EAEA;IACE,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,8BAA8B;EAChC;;EAEA;IACE,2CAA2C;EAC7C;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;IACtB,YAAY;IACZ,0CAA0C;IAC1C,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;;;EAGA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,gCAAgC;IAChC,mCAAmC;IACnC,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,UAAU;IACV,kBAAkB;EACpB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,SAAS;IACT,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,4CAA4C;EAC9C;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE;;MAEE,OAAO;MACP,wBAAwB;IAC1B;;IAEA;;MAEE,sBAAsB;MACtB,2BAA2B;IAC7B;;IAEA;MACE,uBAAuB;MACvB,wBAAwB;IAC1B;EACF;;AAEF","sourcesContent":[".Instructions {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 2vh;\n  font-family: 'Courier New', Courier;\n  font-size: 16px;\n  color: rgb(138, 122, 89);\n  margin-left: 2lvw;\n}\n\n[data-theme='dark'] .Instructions {\n  color: rgb(45, 184, 154);\n}\n\n.tennis-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-top: 2vh;\n}\n\n.big-box {\n  width: 15vw;\n  height: 65vh;\n  margin-left: 4vw;\n  margin-right: 4vw;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.big-box img {\n  width: 100%;\n  height: 100%;\n  object-fit: scale-down;\n  /* object-fit: cover; */\n}\n\n.calendario-wrapper {\n  position: absolute;\n  top: 0;\n  left: 33%;\n  align-self: center;\n  z-index: 2;\n  top: 30%;\n}\n\n.torneo {\n  align-self: center;\n  position: absolute;\n  width: 90%;\n  z-index: 1;\n  top: 40%;\n}\n\n.loading-container {\n  top: 70%;\n  z-index: 1;\n}\n\n.resultado-prediccion {\n  position: absolute;\n  top: 75%;\n  z-index: 1;\n}\n\n\n.button {\n  position: absolute;\n  left: 50%;\n  top: 85%;\n  transform: translate(-50%, -50%);\n  background-color: rgb(39, 117, 100);\n  color: white;\n  padding: 10px 32px;\n  cursor: pointer;\n  border-radius: 4px;\n  z-index: 2;\n}\n\n[data-theme='light'] .button {\n  background-color: rgb(204, 197, 176);\n  color: rgb(82, 68, 49);\n}\n\n.button:hover {\n  background-color: rgb(102, 86, 64);\n}\n\n.buscador-left,\n.buscador-right {\n  width: calc(45vh + 30px);\n  height: calc(65vh + 30px);\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin-top: 3vh;\n}\n\n.ganador {\n  border: 10px solid rgb(39, 117, 100);\n  border-radius: 3%;\n}\n\n\n[data-theme='light'] .ganador {\n  border: 10px solid rgb(155, 135, 93);\n}\n\n.componentes-abajo {\n  display: relative;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  margin-top: 2vh;\n  width: 15vw;\n  height: auto;\n  max-height: 70vh;\n  margin: 4vw;\n}\n\n@media screen and (max-width: 1000px) {\n\n  .componentes-abajo {\n    display: flex;\n    flex-direction: row;\n  }\n\n  .buscador-left,\n  .buscador-right {\n    width: calc(40vw + 3vw);\n    height: calc(35vh + 3vw);\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    margin-top: 2vh;\n  }\n\n  [data-theme='light'] .ganador {\n    border: 3px solid rgb(155, 135, 93);\n  }\n\n  .ganador {\n    border: 3px solid rgb(155, 135, 93);\n    border-radius: 3%;\n  }\n\n  .big-box {\n    width: 10vw;\n    height: 35vh;\n    margin: 1vw;\n  }\n\n  .big-box img {\n    width: 50%;\n    object-fit: scale-down;\n  }\n\n  .buscador-container {\n    width: 40vw;\n    height: 35vh;\n  }\n\n  .buscador-jugadores {\n    height: 4vh;\n  }\n\n  .ul-jugadores {\n    max-height: 30vh;\n  }\n\n  .ul-buscador {\n    max-height: 20vh;\n  }\n\n  .imagen {\n    height: 30.5vh;\n  }\n\n  .calendario {\n    width: 20vw;\n    height: 3vh;\n    align-self: start;\n    margin-left: 10vw;\n  }\n\n  .calendario-wrapper {\n    position: relative;\n    align-self: start;\n    top: 0vh;\n  }\n\n  .calendario,\n  .input-jugadores {\n    font-size: x-small;\n    padding: 0px;\n  }\n\n  .buscador-torneo {\n    height: 3vh;\n    width: 65vw;\n    font-size: x-small;\n    margin-left: 10vw;\n  }\n\n  .contenedor-rondas-buttons {\n    width: 75vw;\n    display: flex;\n    justify-content: space-between;\n  }\n\n  .ronda-seleccionada {\n    border: 0.3vh solid rgba(177, 147, 50, 0.7);\n  }\n\n  .contenedor-rondas-buttons button {\n    font-size: x-small;\n    justify-content: start;\n    flex-grow: 1;\n    background-color: rgba(179, 179, 179, 0.7);\n    height: 4vh;\n    margin: 0 1vw;\n    border-radius: 15%;\n  }\n\n\n  .calendario-opt {\n    font-size: x-small;\n  }\n\n  .torneo {\n    position: relative;\n  }\n\n  .button {\n    position: absolute;\n    left: 50%;\n    top: 25vh;\n    transform: translate(-50%, -50%);\n    background-color: rgb(39, 117, 100);\n    color: white;\n    padding: 3px 6px;\n    cursor: pointer;\n    border-radius: 10px;\n    z-index: 2;\n    font-size: x-small;\n  }\n\n  .resultado-prediccion {\n    top: 25vh;\n  }\n\n  .loading-container {\n    top: 25vh;\n    position: absolute;\n    display: flex;\n    overflow: hidden;\n    font-size: x-small;\n  }\n\n  .tennis-ball {\n    width: 15px;\n    height: 15px;\n    position: relative;\n    animation: moveTennisBall 2s linear infinite;\n  }\n\n  .loading-text {\n    font-size: 8px;\n    color: #7c7979;\n    margin-left: 0%;\n  }\n\n  @keyframes moveTennisBall {\n\n    0%,\n    100% {\n      left: 0;\n      transform: translateY(0);\n    }\n\n    25%,\n    75% {\n      left: calc(50% - 15px);\n      transform: translateY(20px);\n    }\n\n    50% {\n      left: calc(100% - 15px);\n      transform: translateY(0);\n    }\n  }\n\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
